import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../../config';
import { TextInputField, NumberField, TypeaheadInput } from '../../../commons/Inputs';
import Modal from '../../../commons/Modal/Modal';

let $ = window.jQuery;
let Handlebars = window.Handlebars;

export default class PrescriptionForm extends Component {
    state = {
        isSaving: false,
        template_id: 0,
        medicineName: '',
        qty: 0,
        sig: ''
    };

    handleSelectedTemplate = (data) => {
        console.log(data);
        if (data.id) {
            this.setState({
                template_id: data.id,
                medicineName: data.label,
                qty: 0,
            });
        }
    };

    handleCloseModal = () => {

    };

    handleSavePrescription = () => {
        this.setState({ isSaving: true });

        let data = {
            template_id: this.state.template_id,
            sig: this.state.sig,
            qty: this.state.qty
        };

        let url = `${config.apiUrl}patients/${this.props.patientId}/prescriptions`;

        axios.post(url, data).then((res) => {
            console.log(res);
            this.setState({ 
                isSaving: false,
                sig : '',
                qty : 0,
                medicineName : '' 
            });
            $('#prescriptionModal').modal('hide');

            this.props.getPrescriptions();
        }).catch((error) => {
            console.log(error);
            this.setState({ isSaving: false });
            $('#prescriptionModal').modal('hide');
        });
    };

    render() {
        let medicineTemplate = Handlebars.compile([
            '<div class="media-body">',
            '<h4 class="media-heading">{{label}}</h4>',
            '</div>',
            '</div>'
        ].join(''));

        return (
            <Modal id="prescriptionModal" header="Prescription"
                   onNegativeClickEvent={this.handleCloseModal}
                   onPositiveClickEvent={this.handleSavePrescription}
                   positiveButton="Save"
                   negativeButton="Close"
                   isSaving={this.state.isSaving}>

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <TypeaheadInput val={this.state.medicineName} id="generic"
                                        label="Medicine *" help="Type something to start searching for medicine"
                                        // eslint-disable-next-line
                                        handleSelectedData={this.handleSelectedTemplate}
                                        emptySearchText="Nothing Found. Have you created a prescription template already?"
                                        suggestionListTemplate={medicineTemplate}
                                        searchURL="prescription-templates/search"
                                        typeAheadName="searchMedicine"
                                        display="label" />

                    </div>

                    <div className="col-md-6 col-sm-6">
                        <NumberField val={this.state.qty > 0 ? this.state.qty.toString() : ''} id="qty"
                                     label="Quantity"
                                     help="How many?"
                                     onChange={(e) => { this.setState({qty: e.target.value}) }} />
                    </div>

                    <div className="col-md-6 col-sm-6">
                        <TextInputField val={this.state.sig} id="sig"
                                        label="Sig."
                                        help="Medication Instruction"
                                        onChange={(e) => { this.setState({sig: e.target.value}) }} />
                    </div>
                </div>
            </Modal>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Prescription/PrescriptionForm.js
 **/